import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import rightArrow from '../../images/right-arrow-gray.svg';
import rightArrowLight from '../../images/right-arrow-lightgray.svg';
import { Container, InnerContainer, ChildLink, ParentLink } from './styles';
import useExternalBanner from 'hooks/useExternalBanner';

const Breadcrumbs = ({
  breadcrumbs,
  absoluteMode,
  simpleHeader,
  subNav,
  stickyWithoutHeader,
  theme,
  layout,
}) => {
  const [isMobile, setMobile] = useState(false);
  const darkTheme = theme === 'dark';
  const { bannerHeight } = useExternalBanner();
  useEffect(() => {
    if (typeof window === 'object') {
      setMobile(window.innerWidth <= 576);
    }
  }, []);

  const formatBreadcrumb = (breadcrumb, index) => {
    if (breadcrumb.url) {
      return (
        <Link to={breadcrumb.url} key={`breadcrumb-${index}`}>
          <ParentLink darkTheme={darkTheme}>
            {isMobile && (
              <img
                src={darkTheme ? rightArrow : rightArrowLight}
                className="breadcrumb--arrow reverse"
              />
            )}
            {breadcrumb.title}
            {breadcrumb.icon && <img src={breadcrumb.icon} className="breadcrumb--icon" />}
            {!isMobile && breadcrumbs.length > index + 1 && (
              <img src={darkTheme ? rightArrow : rightArrowLight} className="breadcrumb--arrow" />
            )}
          </ParentLink>
        </Link>
      );
    }

    return (
      <ChildLink key={`breadcrumb-${index}`} darkTheme={darkTheme}>
        {breadcrumb.title}
        {breadcrumb.icon && <img src={breadcrumb.icon} className="breadcrumb--icon" />}
      </ChildLink>
    );
  };

  return (
    <Container
      className="breadcrumb--wrapper"
      absoluteMode={absoluteMode}
      simpleHeader={simpleHeader}
      subNav={subNav}
      stickyWithoutHeader={stickyWithoutHeader}
      bannerHeight={bannerHeight}
    >
      {breadcrumbs && (
        <InnerContainer layout={layout}>
          {!isMobile
            ? breadcrumbs.map((crumb, index) => {
                return formatBreadcrumb(crumb, index);
              })
            : formatBreadcrumb(breadcrumbs.filter(crumb => crumb.url).pop(), 0)}
        </InnerContainer>
      )}
    </Container>
  );
};

export default Breadcrumbs;
